'use strict';

angular.module('licensure.services')
    .factory('Levels', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/Levels', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getUserLevelProgress: function (args) {
                var d = $q.defer();
                $http
                    .get(apiLocation + '/api/EducationModule/UserLevelProgressByApplicationType/', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getEducationVerificationDates: function (args) {
                var d = $q.defer();
                $http
                    .get(apiLocation + '/api/EducationModule/EducationVerificationDates/', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;